var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 10,
    viewBox: "0 0 4 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.24975C1 0.835653 1 0 2.03554 0C3.07109 0 3 0.835678 3 1.24975V4.74881C3 5.16286 3 6.00002 2 6.00002C1 6.00002 1 5.16283 1 4.74881V1.24975ZM2.03554 10C1.40557 10 0.893066 9.49554 0.893066 8.87537C0.893066 8.25522 1.40554 7.75074 2.03554 7.75074C2.66552 7.75074 3.17799 8.25522 3.17799 8.87537C3.17802 9.49552 2.66555 10 2.03554 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.44bc905258344a1949f9ab09fd98bfed.svg";
export { ForwardRef as ReactComponent };